export const TabRoom = {
  RoomAttributes: 'roomAttributes',
  Documentation: 'documentation'
} as const;
export const headerTabRoom = [
  { label: 'Location Attributes', param: TabRoom.RoomAttributes, value: 0 },
  { label: 'Documentation', param: TabRoom.Documentation, value: 1 }
];

export const headerTabAssetIssues = [
  { label: 'Assets', value: 0 },
  { label: 'Issues', value: 1 },
  { label: 'Archive photo', value: 2 }
];
export type TabRoomType = (typeof TabRoom)[keyof typeof TabRoom];

export const ROOM_LEVEL_ISSUES = [
  { label: 'Description', key: 'description', width: 160 },
  { label: 'Validated', key: 'validated', width: 160 },
  { label: 'Action By', key: 'actionBy', width: 160 },
  { label: 'Action By Date', key: 'actionByDate', width: 160 },
  { label: 'Status', key: 'status', width: 150 },
  { label: 'Date Resolved', key: 'dateResolved', width: 150 },
  { label: 'Date Created', width: 150, key: 'createdAt' },
  { label: 'Last Modified', width: 150, key: 'updatedAt' },
  { label: 'Photos', key: 'photo', width: 150 },
  { label: 'Actions', key: 'action', width: 200 }
];

export const CUSTOMER_ATTRIBUTES = [
  { label: 'Field', width: 250 },
  { label: 'Description' },
  { label: 'Photos', width: 180 }
];
export const HEADER_REPORT = [
  { label: 'Asset Name', sort: 'name', width: 150 },
  { label: 'Asset Type', sort: 'typeId', width: 150 },
  { label: 'Issue', width: 150 },
  { label: 'Model', sort: 'model.name', width: 150 },
  { label: 'Validated', sort: 'validated', width: 150 },
  { label: 'Tag', width: 150 },
  { label: 'Date Created', width: 150 },
  { label: 'Last Modified', width: 150 },
  { label: 'Photos', width: 120 },
  { label: 'Attributes', width: 150 },
  { label: 'Preview', width: 150 },
  { label: 'Actions', width: 200 }
];
export const HEADER_REPORT_PREVIEW = [
  { label: 'Asset Name', width: 150 },
  { label: 'Asset Type', width: 150 },
  { label: 'Condition', width: 150 },
  { label: 'Issue', width: 150 },
  { label: 'Model', width: 150 },
  { label: 'Validated', width: 150 },
  { label: 'Tag', width: 150 },
  { label: 'Date Created', width: 150 },
  { label: 'Last Modified', width: 150 },
  { label: 'Photo', width: 80 }
];

export const HEADER_ROOM_LEVEL_ISSUES_TAB = [
  { label: 'Client Name', sort: 'submitted.room.client.clientName', width: 150 },
  { label: 'Main Location', sort: 'submitted.room.parent.parent.parent.parent.name', width: 150 },
  { label: 'Sub Location 1', sort: 'submitted.room.parent.parent.parent.name', width: 150 },
  { label: 'Sub Location 2', sort: 'submitted.room.parent.parent.name', width: 150 },
  { label: 'Vertical Level', sort: 'submitted.room.parent.name', width: 150 },
  { label: 'Location', sort: 'submitted.room.name', width: 150 },
  { label: 'Description', sort: 'description', width: 250 },
  { label: 'Validated', sort: 'validated', width: 100 },
  { label: 'Action By', sort: 'actionBy', width: 180 },
  { label: 'Action By Date', sort: 'actionByDate', width: 180 },
  { label: 'Status', sort: 'status', width: 120 },
  { label: 'Date Resolved', width: 120 },
  { label: 'Date Created', width: 150 },
  { label: 'Last Modified', width: 150 },
  { label: 'Photo', width: 180 }
];
export const HEADER_ISSUES_MANAGEMENT = [
  { label: 'Equipment ID', sort: 'equipmentId', width: 150 },
  { label: 'Action By', width: 120 },
  { label: 'Action By Date', width: 140 },
  { label: 'Description', sort: 'description', width: 300 },
  { label: 'Resolution Date', sort: 'resolutionDate', width: 150 },
  { label: 'Status', width: 100 },
  { label: 'Date Created', width: 150 },
  { label: 'Last Modified', width: 150 },
  { label: 'Photos', width: 180 },
  { label: 'Actions', width: 200 }
];

export const HEADER_ISSUES_MANAGEMENT_VALIDATION = [
  { label: 'Equipment ID', sort: 'equipmentId', width: 150 },
  { label: 'Description', sort: 'description', width: 300 },
  { label: 'Date Created', sort: 'createdAt', width: 150 },
  { label: 'Last Modified', width: 150 },
  { label: 'Resolution Date', sort: 'resolutionDate', width: 150 },
  { label: 'Action By', width: 120 },
  { label: 'Action By Date', width: 140 },
  { label: 'Status', width: 100 },
  { label: 'Actions', width: 200 }
];
